<template>
  <Modal :id="'cmp-settings-service-form'" @cancelled="onCancel" :loadingFlag="loadingFlag">
    <template slot="header"> {{title}} {{$t('service_string')}}</template>

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'channel_name'"
          v-bind="textFieldConfig"
          :value="channel.channel_name"
          :placeholder="$t('service')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <TextField
          class="m1"
          :id="'identifier'"
          v-bind="textFieldConfig"
          :value="channel.identifier"
          :placeholder="$t('identifier')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onFormSubmit">{{$t('ok')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import { createFormModalMixin, createFormItemMixin } from '../../../../dt-plugins/form-modal/form-modal';
import { AccountingSettingsService } from '../../services/accounting-settings.service';

export default {
  components: {
    Modal,
  },
  props: {

  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: 'channel_id',
      itemKey: 'channel',
      detailsHttpReq: AccountingSettingsService.findChannelDetails,
    }),
  ],
  computed: {
    
  },
  methods: {
    get_channel: function() {
      return {
        created: "",
        channel_name: "",
        sorter: null,
        channel_id: null,
        last_modified: "",
        identifier: ""
      };
    }
    //MARK: Methods
  }
};



</script>

<style lang="scss">
.cmp-settings-service-form {
  
}
</style>
